import React from "react";
import { Header as MMTHeader } from 'pwa-mmt-ui-header';
import { loginAction } from './redux/actions/LoginActions';
import { actionSetOrResetLoginModal } from './pages/travellersDetails/store/actions/TravellerActions';
import {connect} from "react-redux";

const ConnectedHeader = (props) => {
   const MY_BIZ_EXPERIMENTS = {
    mybiztrains: true
  };
    return (
      <MMTHeader
        selectedTabName="Trains"
        onLoginFlowComplete={() => props.loginAction(true)}
        onLogout={() => props.loginAction(false)}
        onModalChange={() => props.actionSetOrResetLoginModal(false)}
        activeModal={props.showLoginModal ? "LOGIN" : undefined}
        myBizExperiments={MY_BIZ_EXPERIMENTS}
      />
    );
}

const mapStateToProps = (state) => {
  const { traveller : { showLoginModal } } = state;
  return {
    showLoginModal
  }
}

const mapDispatchToProps = (dispatch) => ({
    loginAction : (isLoggedIn) => dispatch(loginAction(isLoggedIn)),
    actionSetOrResetLoginModal : (showLoginModal) => dispatch(actionSetOrResetLoginModal(showLoginModal))
});

export default connect(mapStateToProps,mapDispatchToProps)(ConnectedHeader);
